import React, { useEffect } from "react";
import axios from "axios";

const AdCheckComponent = () => {
  useEffect(() => {
    axios
      .get(
        "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4574266110812955",
        { timeout: 5000 } // timeout 5s tránh treo trang
      )
      .then(() => {
        // Script loaded successfully, do nothing
      })
      .catch(() => {
        // Failed to load, possibly blocked
        window.alert("🚫 AdBlock detected or script failed to load!");
        window.location.href = "/shop/profiles/home?webappmode=showadview";
      });
  }, []);

  return null; // no div rendered
};

export default AdCheckComponent;
